<template>
    <c-app-content
        :sites           = "siteContext ? [ { id: siteContext } ] : null"
        :hide-top        = "!siteContext"
        :search-on-focus = "false"
        @initialized     = "onInitialized"
    >
        <template v-slot:content>
            <div
                id="incidents-search-panel"
                class="overview-panel v-flex"
                :key="count"
            >
                <c-inc-overview-menu
                    :site     = "siteContext"
                    @download = "onDownload"
                    @refresh  = "onRefresh"
                    @filter   = "onFilter"
                />
                <div>
                    <table id="inc-overview" class="table table-hover table-bordered">
                        <thead>
                        <tr class="table-header" >
                            <th class="text-center" >
                                <v-table-header-cell
                                    group="inc.overview.header"
                                    first   = "state"
                                    v-model = "sort"
                                />
                            </th>

                            <th class="text-center" >
                                <v-table-header-cell
                                    group="inc.overview.header"
                                    first   = "begin"
                                    second  = "end"
                                    v-model = "sort"
                                />
                            </th>

                            <th class="text-center" >
                                <v-table-header-cell
                                    group="inc.overview.header"
                                    first   = "type"
                                    second  = "status"
                                    :sortable="{ first: true, second: false}"
                                    v-model = "sort"
                                />
                            </th>

                            <th class="text-center" >
                                <v-table-header-cell
                                    group="inc.overview.header"
                                    first   = "user"
                                    second  = "id"
                                    v-model = "sort"
                                />
                            </th>

                            <th class="text-center" >
                                <v-table-header-cell
                                    group="inc.overview.header"
                                    first   = "fabricNo"
                                    second  = "siteId"
                                    v-model = "sort"
                                />
                            </th>

                            <th class="text-center">
                                <v-table-header-cell
                                    group   ="inc.overview.header"
                                    first   = "street"
                                    second  ="city"
                                    v-model = "sort"
                                />
                            </th>

                            <th class="text-center">Angebot<br>Auftrag</th>
                            <th class="text-center">Rechnung<br>{{ filter && filter.field === "incidentMntQuery" ? 'Wartungsnehmer' : 'Ausf. Unternehmen' }}  </th>
                            <th class="text-center">Beschreibung</th>
                            <th class="text-center">Maßname</th>
                        </tr>
                        </thead>
                    </table>
                </div>
            </div>
        </template>
    </c-app-content>
</template>

<script>

import $ from 'jquery';
import 'datatables.net';

import main                          from "@/main";
import Vue                           from "vue";
import SearchRequest from "@/modules/core/service/private/SearchRequest";
import Core                          from "@/modules/core/service/Core.js";
import Inc                           from "@/modules/inc/service/Inc.js";
import tables                        from '@/assets/js/tables'
import security                      from '@/main'
import CIncOverviewMenu              from "@/modules/inc/overview/CIncOverviewMenu.vue";
import VTableHeaderCell              from "@/modules/core/components/utils/VTableHeaderCell.vue";
import CAppContent                   from "@/modules/core/components/app/CAppContent.vue";
import CIncOverviewTypeStepEntryCell from "@/modules/inc/overview/CIncOverviewTypeStepEntryCell.vue";
import CIncOverviewStatusCell        from "@/modules/inc/overview/CIncOverviewStatusCell.vue";

const Const = {
    table: {
        id : "#inc-overview",
    },
};

export default {
    name: "MIncOverview",

    components: {
        CAppContent,
        VTableHeaderCell,
        CIncOverviewMenu,
    },

    data: () => ({
        count  : 0,
        table  : null,
        filter : null,
        siteContext: null,
        sort       : {
            column: "begin",
            dir   : "DESC"
        }
    }),

    watch: {
        sort: {
            handler: function () {
                this.onRefresh();
            },
            deep: true
        }
    },

    computed: {
        columns () {
            const self = this;
            return  [
                {
                    width: '25px',
                    class: 'hc-site-select',
                    render: function (data, type, row) {
                        const div = $('<div>', { id: row.key + "-s" });
                        self.createStatusCell (row, row.key + "-s");
                        return div.prop('outerHTML');
                    }
                },
                {
                    width: '80px',
                    class: 'table-textarea',
                    render: function ( data, type, row ) {
                        return tables.dates(row.date, row.finished);
                    }
                },
                {
                    width: '220px',
                    class: 'table-textarea',
                    render: function ( data, type, row ) {
                        const div = $('<div>', { id: row.key });
                        self.createStepCell (row, row.key);
                        return div.prop('outerHTML');
                    }
                },
                {
                    width: '150px',
                    class: 'table-textarea',
                    render: function ( data, type, row ) {
                        const icon = row.file ? "file-multiple-outline" : "file-outline";
                        const itag = "<i class='inc-overview-icon mdi mdi-" + icon + "></i>";
                        return tables.line(row.responsible)  + tables.line(itag) + (row.externalId ? row.incidentId + " / " + row.externalId : row.incidentId);
                    }
                },
                {
                    width: '170px',
                    class: 'table-textarea text-center pl-0 pr-0',
                    render: function ( data, type, row ) {
                        const site = row.unit;
                        return tables.line(site ? site.fabricNo : '') + tables.line (site ? site.id : '');
                    }
                },
                {
                    width: '230px',
                    class: 'table-textarea',
                    render: function ( data, type, row ) {
                        if (row.unit) {
                            return tables.line(row.unit.street) + tables.line(row.unit.zip + ' ' + row.unit.city);
                        }

                        return '';
                    }
                },
                {
                    width: '120px',
                    class: 'table-textarea',
                    render: function ( data, type, row ) {
                        return tables.line(row.bidNo ? row.bidNo : '-/-') + tables.line (row.orderNo);
                    }
                },
                {
                    width: '150px',
                    class: 'table-textarea',
                    render: function ( data, type, row ) {
                        let manufacturer = row.manufacturer;
                        if (self.filter && self.filter.field === "incidentMntQuery") {
                            manufacturer = row.unit.mntCompany;
                        }
                        return tables.line(row.invoiceNo) + tables.line (manufacturer ? manufacturer : '-/-');
                    }
                },
                {
                    width: '17%',
                    class: 'table-textarea',
                    render: function ( data, type, row ) {
                        return tables.textarea (row.description);
                    }
                },
                {
                    width: '17%',
                    class: 'table-textarea',
                    render: function ( data, type, row ) {
                        return tables.textarea (row.measure);
                    }
                },
            ]
        },

        incidentFlter () {
            return this.$store.getters.preferences["userFilter"]
        },
    },

    created() {
        this.$bus.$on(this.$events.refresh, this. refresh);
    },

    beforeDestroy() {
        this.$bus.$off(this.$events.refresh, this.refresh);
    },

    methods: {
        onInitialized () {
            this.filter = this.$route.params;
            this.count ++;
            this.$nextTick(() => {
                this.load(this.filter);
            });
        },

        refresh (filter) {
            if (filter) {
                this.load(filter);
            }
        },

        load(filter) {
            this.filter = filter;
            if (this.filter.field === "incidentSiteIdQuery") {
                this.siteContext = this.filter.value;
                this.$store.dispatch("setContext", {
                    incident: null,
                    site    : this.filter.value
                })
            } else {
                this.siteContext = null;
            }
            this.count ++;
            this.$nextTick(() => {
                this.filter.ignoreDeleted = this.incidentFlter.ignoreDeleted;
                this.show(this.filter);
            });
        },

        onDownload () {
            $(Const.table.id).DataTable().button('.buttons-csv').trigger();
        },

        onFilter () {
            this.load(this.filter)
        },

        onRefresh () {
            this.show(this.filter);
        },

        async show (filter) {
            const self = this;
            $.fn.DataTable.ext.pager.numbers_length = 10;

            if (this.table) {
                this.table.api().destroy ();
            }

            this.table = $(Const.table.id).dataTable({
                dom: 'Bfrtip',
                buttons: [
                    'csv',
                    'print'
                ],
                processing  : false,
                serverSide  : true,
                paging      : true,
                searching   : false,
                ordering    : false,
                info        : true,
                autoWidth   : false,
                lengthChange: false,
                deferRender : true,
                destroy     : true,
                idSrc       : 'id',
                rowId       : 'id',
                select      : true,
                language    : tables.language(),
                columns     : this.columns,
                infoCallback: function (settings, start, end, max, total) {
                    if (total === 0) return '';
                    return start + " bis " + end + ' von insgesamt ' + total + ' Ereignissen';
                },
                rowCallback: function( row, data ) {
                    tables.deleted (row, data);
                },
                ajax        : {
                    headers : security.jsonHeader(),
                    dataType: 'json',
                    type    : 'POST',
                    url     : SearchRequest.url("/incident"),
                    data: function ( d ) {
                        return JSON.stringify(SearchRequest.table(d, self.sort, SearchRequest.incidentFilter(filter)));
                    },
                    dataSrc: 'data',
                    beforeSend: function () {
                        Core.loading(self, true);
                    },
                    complete: function () {
                        Core.loading(self, false);
                    },
                    error: function (xhr) {
                        if (xhr.status === 401) {
                            security.logout();
                        }
                    }
                },
           });

            self.table.on( 'click', 'tr', function () {
                const rowdata = self.table.api().row( $(this)).data();
                console.log("rowdata", rowdata)
                if (rowdata) {
                    const stepName = rowdata.steps && rowdata.steps.length > 0 ? rowdata.steps[0].name : null;
                    Inc.goto(self, rowdata.incidentId ? rowdata.incidentId : rowdata.id, rowdata.unit ? rowdata.unit.id : null, stepName);
                }
            });
        },

        createStatusCell (row, id) {
            this.$nextTick(() => {
                const i18n = main.i18n();
                new Vue({el: "#" + id, ...CIncOverviewStatusCell, i18n, propsData: {row: row}});
            });
        },

        createStepCell (row, id) {
            this.$nextTick(() => {
                const i18n = main.i18n();
                const statusCell = new Vue({el: "#" + id, ...CIncOverviewTypeStepEntryCell, i18n, propsData: {row: row}});
                statusCell.$on ("clipboard", (selected) => {
                    this.onClipboard(selected);
                });
            });
        },

        onClipboard (selected) {
            const table = this.table;
            this.$store.dispatch("refreshClipboard", selected.unit.customer.id);

            this.table.api().rows ().every (function (index) {
                const row = table.api().row(index);
                const data = row.data ();
                if (data.incidentId === selected.incidentId && data.unit.id === selected.unit.id) {
                    data.clipboardEntry = selected.clipboardEntry;
                    table.api().row (index).data (data);
                }
            });
        },
    }
}
</script>

<style scoped>

::v-deep .dt-buttons {
    display: none;
}

::v-deep  table, tr, td {
    border-spacing: 0;
}

</style>
<style>
.inc-overview-icon {
    padding-right: 3px;
}
</style>